import html from './images/html.jpg';
import js from './images/js.jpg';
import css from './images/css.jpg';

export const cardsData = [
  {
    id: '1',
    image: html,
    title: 'Kurs Tworzenia Stron WWW w HTML i CSS od Podstaw do Eksperta',
    date: '12.16.2020',
    autor: 'Jan Kowalski',
    moduls: 5,
    students: 28,
    comments: 2,
  },
  {
    id: '2',
    image: js,
    title: 'Kurs JavaScript w praktyce',
    date: '12.16.2020',
    autor: 'Jan Kowalski',
    moduls: 5,
    students: 28,
    comments: 2,
  },
  {
    id: '3',
    image: css,
    title: 'Kurs CSS Grid',
    date: '12.16.2020',
    autor: 'Jan Kowalski',
    moduls: 5,
    students: 28,
    comments: 2,
  },
  {
    id: '4',
    image: html,
    title: 'Kurs Tworzenia Stron WWW w HTML i CSS od Podstaw do Eksperta',
    date: '12.16.2020',
    autor: 'Jan Kowalski',
    moduls: 5,
    students: 28,
    comments: 2,
  },
  {
    id: '5',
    image: css,
    title: 'Kurs CSS Grid',
    date: '12.16.2020',
    autor: 'Jan Kowalski',
    moduls: 5,
    students: 28,
    comments: 2,
  },
];

export const dataInactive = [
  {
    id: '6',
    image: html,
    title: 'Kurs HTML i CSS',
    date: '12.16.2020',
    autor: 'Jan Kowalski',
    moduls: 5,
    students: 28,
    comments: 2,
  },
  {
    id: '7',
    image: js,
    title: 'JavaScript w praktyce',
    date: '12.16.2020',
    autor: 'Jan Kowalski',
    moduls: 5,
    students: 28,
    comments: 2,
  },
  {
    id: '8',
    image: css,
    title: 'CSS',
    date: '12.16.2020',
    autor: 'Jan Kowalski',
    moduls: 5,
    students: 28,
    comments: 2,
  },
  {
    id: '9',
    image: html,
    title: 'HTML i CSS od Podstaw do Eksperta',
    date: '12.16.2020',
    autor: 'Jan Kowalski',
    moduls: 5,
    students: 28,
    comments: 2,
  },
  {
    id: '10',
    image: css,
    title: 'CSS Grid',
    date: '12.16.2020',
    autor: 'Jan Kowalski',
    moduls: 5,
    students: 28,
    comments: 2,
  },
];

export const dataWorkingVersion = [
  {
    id: '11',
    image: html,
    title: 'Kurs Tworzenia Stron WWW w HTML i CSS',
    date: '12.16.2020',
    autor: 'Jan Kowalski',
    moduls: 5,
    students: 28,
    comments: 2,
  },
  {
    id: '12',
    image: js,
    title: 'Kurs JavaScript',
    date: '12.16.2020',
    autor: 'Jan Kowalski',
    moduls: 5,
    students: 28,
    comments: 2,
  },
  {
    id: '13',
    image: css,
    title: 'CSS Grid',
    date: '12.16.2020',
    autor: 'Jan Kowalski',
    moduls: 5,
    students: 28,
    comments: 2,
  },
  {
    id: '14',
    image: html,
    title: 'Kurs Tworzenia Stron WWW w HTML i CSS',
    date: '12.16.2020',
    autor: 'Jan Kowalski',
    moduls: 5,
    students: 28,
    comments: 2,
  },
  {
    id: '15',
    image: css,
    title: 'Grid',
    date: '12.16.2020',
    autor: 'Jan Kowalski',
    moduls: 5,
    students: 28,
    comments: 2,
  },
];
